import CheckOption from '../models/CheckOption';
import Data from './Data';

class CheckOptions extends Data {
    constructor() {
        super(CheckOption);
    }

    async getForKey(key) {
        return (await this.all())
            .filter(option => option.key === key)
            .sort((a, b) => a.value.localeCompare(b.value));
    }

    async getOptionsForKey(key) {
        return (await this.getForKey(key)).map(option => option.forWidget());
    }
}

export default new CheckOptions();
